import { ApiError, request } from './api';
import type { CatalogResponse } from './types';

const retryDelays = [250, 750, 1500];

function retryable(error: unknown) {
  return error instanceof TypeError || (error instanceof ApiError && [500, 502, 503, 504].includes(error.status));
}

function waitForRetry(delay: number, signal?: AbortSignal) {
  return new Promise<void>((resolve, reject) => {
    const abort = () => {
      clearTimeout(timer);
      signal?.removeEventListener('abort', abort);
      reject(new DOMException('商品查询已取消', 'AbortError'));
    };
    const timer = setTimeout(() => { signal?.removeEventListener('abort', abort); resolve(); }, delay);
    signal?.addEventListener('abort', abort, { once: true });
    if (signal?.aborted) abort();
  });
}

/** Retry only the read-only catalog, including brief development-server restarts. */
export async function requestDealerCatalog(path: string, signal?: AbortSignal): Promise<CatalogResponse> {
  for (let attempt = 0; ; attempt += 1) {
    try {
      return await request<CatalogResponse>(path, signal ? { signal } : {});
    } catch (error) {
      if (signal?.aborted) throw error;
      const delay = retryDelays[attempt];
      if (retryable(error) && delay !== undefined) {
        await waitForRetry(delay, signal);
        continue;
      }
      if (error instanceof TypeError) throw new ApiError('CATALOG_CONNECTION_FAILED', '暂时无法连接商品服务，请稍后重试', 0);
      if (error instanceof ApiError && error.code === 'REQUEST_FAILED') {
        throw new ApiError(error.code, `商品服务请求失败（HTTP ${error.status}），请稍后重试`, error.status);
      }
      throw error;
    }
  }
}
